import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, } from '@angular/router';
import { PaymentCollectionService } from '../../service/payment-collection.service';
import { PaymentModeDisplay, PaymentCollectionResponseByTransactionId } from '../../model/payment/PaymentCollectionRequest';
import { NotFoundError } from '../../errors/NotFoundError';
import { Keys, StorageService } from '../../service/storage.service';
import { ConfigService } from '../../service/config.service';
import { FinzyVersion } from '../../model/common/investment-product';

@Component({
  selector: 'app-payment-success',
  templateUrl: './payment-success.component.html',
  styleUrls: ['./payment-success.component.scss']
})
export class PaymentSuccessComponent implements OnInit {

  // input row one to payment success template
  rowOne = {
    successLogo: "../../../assets/images/payment-collection/payment_successful.svg",
    successMsg: "Payment Successful",
    successInfoMsg: "The amount will be credited to your account within <strong>15 minutes</strong>"
  };

  rowTwo = [
    { rowName: 'Payment Type', rowValue: null },
    { rowName: 'Amount Added', rowValue: null },
    { rowName: 'Bank Reference Number', rowValue: null },
  ];

  templateButtonText = "GO TO DASHBOARD";

  public transactionId: string;
  public transactionDetail: PaymentCollectionResponseByTransactionId;
  private getActiveFinzyVersion: string;
  public isComingFromPartnerRetailer: boolean = false;

  constructor(private paymentCollectionService: PaymentCollectionService, private route: ActivatedRoute,
    private router: Router, private storageService: StorageService, private configService: ConfigService) {
  }

  ngOnInit(): void {
    const paymentSuccessRedirectURI = this.storageService.getItem(Keys.PAYMENT_SUCCESS_REDIRECT_URL);
    this.checkIsComingFromPartnerRetailer();
    if (paymentSuccessRedirectURI) {
      this.navigate(paymentSuccessRedirectURI);
    }
    this.transactionId = this.route.snapshot.queryParams['transactionId'];
    this.getActiveFinzyVersion = this.configService.getActiveFinzyVersion();
    this.getTransactionDetail();
  }

  private navigateTo() {
    if (this.getActiveFinzyVersion === FinzyVersion.FINZY_V2) {
      this.router.navigate(['/investment-initial']);
    } else {
      this.router.navigate(['/investorwallet']);
    }
  }

  async getTransactionDetail() {
    const uuid = this.storageService.getItem(Keys.IFA_PAYMENT_LINK_UUID);
    if (uuid) {
      this.markPaymentLinkStatusSuccess(this.transactionId);
    } else {
      try {
        this.transactionDetail = await this.paymentCollectionService.getPaymentCollectionByTransactionId(this.transactionId);
        if (this.transactionDetail.status === 'SUCCESS' || this.transactionDetail.status === 'COMPLETE') {

          this.rowTwo[1].rowValue = this.transactionDetail.amount;
          this.rowTwo[2].rowValue = this.transactionDetail.bankReferenceNumber;

          if (this.transactionDetail.paymentMode === 'DEBIT_CARD') {
            this.transactionDetail.paymentMode = PaymentModeDisplay.DEBIT_CARD;
            this.rowTwo[0].rowValue = PaymentModeDisplay.DEBIT_CARD;
          } else if (this.transactionDetail.paymentMode === 'UPI') {
            this.transactionDetail.paymentMode = PaymentModeDisplay.UPI;
            this.rowTwo[0].rowValue = PaymentModeDisplay.UPI;
          } else if (this.transactionDetail.paymentMode === 'NET_BANKING') {
            this.transactionDetail.paymentMode = PaymentModeDisplay.NET_BANKING;
            this.rowTwo[0].rowValue = PaymentModeDisplay.UPI;
          }
          this.storageService.removeItem(Keys.PAYMENT_PRODUCT);
          this.storageService.removeItem(Keys.AMOUNT);
        } else {
          this.navigateTo();
        }
      }
      catch (error) {
        if (error.status === NotFoundError.statusCode) {
          this.navigateTo();
        }
      }
    }
  }

  async markPaymentLinkStatusSuccess(txnId: string) {
    // this localStorage belong to IFA payment link
    // await this.paymentCollectionService.updatePaymentLinkStatus(txnId)
    //   .then((res) => {
    //     this.storageService.removeItem(Keys.IFA_PAYMENT_LINK_UUID);
    //     this.storageService.removeItem(Keys.PAYMENT_PRODUCT);
    //     this.storageService.removeItem(Keys.AMOUNT);
    //     Toaster.toast('Payment Success', Type.Success);
    //   }).catch((error) => {
    //     if (error instanceof BadRequestError || error instanceof InternalServerError) {
    //       Toaster.toast(error.message, Type.Error);
    //     } else if (error.status === NotFoundError.statusCode) {
    //       Toaster.toast(error.error.message, Type.Error);
    //     } else {
    //       Toaster.toast("Something went wrong, please try again", Type.Error);
    //     }
    //   })
  }

  public onClickDashboard(event) {
    const pathToRedirect = this.storageService.getItem(Keys.PARENT_WALLET_PATH) || this.storageService.getItem(Keys.PAYMENT_SUCCESS_REDIRECT_URL);
    const ifaPaymentLinkUuid = this.storageService.getItem(Keys.IFA_PAYMENT_LINK_UUID);
    if (pathToRedirect) {
      this.navigate(pathToRedirect);
      this.storageService.removeItem(Keys.PARENT_WALLET_PATH);
      this.storageService.removeItem(Keys.PAYMENT_SUCCESS_REDIRECT_URL);
      this.storageService.removeItem(Keys.PAYMENT_FAILED_REDIRECT_URL);
      this.storageService.removeItem(Keys.PAYMENT_REFERENCE_ID);
      this.storageService.removeItem(Keys.PAYMENT_PRODUCT);
      this.storageService.removeItem(Keys.AMOUNT);
    } else if (ifaPaymentLinkUuid) {
      this.storageService.removeItem(Keys.IFA_PAYMENT_LINK_UUID);
      this.storageService.removeItem(Keys.PAYMENT_PRODUCT);
      this.storageService.removeItem(Keys.AMOUNT);
      this.navigate('/invest');
    } else if (event === 'borrower') {
      this.navigate('/borrow/dashboard/applications');
    } else if (this.getActiveFinzyVersion === FinzyVersion.FINZY_V2) {
      this.navigate('/investment-initial');
    } else {
      this.navigate('/investordashboard');
    }
  }

  private navigate(pathToRedirect: string) {
    if (pathToRedirect.startsWith('http')) {
      location.href = pathToRedirect;
    } else {
      this.router.navigate([pathToRedirect]);
    }
  }

  private checkIsComingFromPartnerRetailer() {
    try {
      this.isComingFromPartnerRetailer = Boolean(this.storageService.getItem(Keys.RETAILER_PARTNER_LINK_VALIDATED));
      this.clearRetailerPartnerLocalStorage();
    } catch (e) {
      console.log(e);
    }
  }

  private clearRetailerPartnerLocalStorage(): void {
    if (
      this.storageService.getItem(Keys.PAYMENT_REFERENCE_ID) &&
      this.storageService.getItem(Keys.RETAILER_PARTNER_LINK_VALIDATED)) {
        this.storageService.getItem(Keys.RETAILER_PARTNER_LINK_VALIDATED);
        this.storageService.removeItem(Keys.PAYMENT_REFERENCE_ID);
        this.storageService.removeItem(Keys.TOKEN);
        this.storageService.removeItem(Keys.PROFILE_ID);
    }
  }
}
